type CenteredWindowOptions = {
	getUrl: () => string;
	title?: string;
	width: number;
	height: number;
}

export type NewWindowManager = {
	openOrFocus: (onClose: () => void) => void;
    close: () => void;
}

export class WindowUtils {
	public static createNewWindowWithContent(content: string): Window | null {
		const newWindow = window.open('about:blank', '_blank');
		if (newWindow) {
			newWindow.document.write(content);
		}
		return newWindow;
	}

	public static openCenteredWindow(options: CenteredWindowOptions): WindowProxy | null {
		const left = (window.screen.width - options.width) / 2;
		const top = (window.screen.height - options.height) / 2;

		return window.open(
			options.getUrl(),
			options.title,
			`scrollbars=yes, toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, width=${options.width}, height=${options.height}, top=${top}, left=${left}`
		);
	}

	public static createNewWindowManager(options: CenteredWindowOptions): NewWindowManager {
		let newWindow: Window | null = null;
		let checkInterval: ReturnType<typeof setInterval> | null = null;
		let onCloseCallback: (() => void) | null = null;

		function openOrFocus(onClose: () => void): void {
			if (newWindow && !newWindow.closed) {
				newWindow.focus();
				return;
			}

			newWindow = WindowUtils.openCenteredWindow(options);
			if (!newWindow) throw new Error('Error on KSeF Creator open');

			onCloseCallback = onClose;

			if (checkInterval) clearInterval(checkInterval);

			checkInterval = setInterval(() => {
				if (!newWindow || newWindow.closed) {
					if (checkInterval) clearInterval(checkInterval);
					checkInterval = null;
					newWindow = null;

					if (onCloseCallback) {
						onCloseCallback();
						onCloseCallback = null;
					}
				}
			}, 1000);
		}

		function close(): void {
            newWindow?.close();
		}

		return {
			openOrFocus,
            close
		};
	}
}